<p-overlayPanel #auditOverlay>
  <dl class="d-flex justify-content-end m-0" *ngIf="record.createdDate">
    <dt class="small col-5 p-0" jhiTranslate="global.field.createdDate">Data Criação</dt>
    <dd class="small col-7 p-0">
      <b>{{ record.createdDate | formatMediumDatetime }}</b>
    </dd>
  </dl>
  <dl class="d-flex justify-content-end m-0" *ngIf="record.createdBy">
    <dt class="small col-5 p-0" jhiTranslate="global.field.createdBy">Criado Por</dt>
    <dd class="small col-7 p-0">
      <b>{{ record.createdBy }}</b>
    </dd>
  </dl>
  <dl class="d-flex justify-content-end m-0" *ngIf="record.lastModifiedDate">
    <dt class="small col-5 p-0" jhiTranslate="global.field.lastModifiedDate">Última Modificação</dt>
    <dd class="small col-7 p-0">
      <b>{{ record.lastModifiedDate | formatMediumDatetime }}</b>
    </dd>
  </dl>
  <dl class="d-flex justify-content-end m-0" *ngIf="record.lastModifiedBy">
    <dt class="small col-5 p-0" jhiTranslate="global.field.lastModifiedBy">Modificado Por</dt>
    <dd class="small col-7 p-0">
      <b>{{ record.lastModifiedBy }}</b>
    </dd>
  </dl>
</p-overlayPanel>
<button
  type="button"
  *ngIf="record.id"
  class="btn btn-light btn-sm float-right"
  [pTooltip]="'Auditoria'"
  [appendTo]="'body'"
  (click)="auditOverlay.toggle($event)"
>
  <fa-icon [icon]="faHistory" [fixedWidth]="true"></fa-icon>
</button>
